import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import {
  Button,
  Fade,
  withStyles,
  CircularProgress,
  Input,
} from '@material-ui/core'

import { overlay, loadingSpinner } from '../../variables/styles'
import RegularCard from '../Cards/RegularCard.js'
import { categoryCareInfo as categoryCareInfoActions } from '../../actions'
import formPropTypes from '../../constants/formPropTypes'
import CustomTextField from 'components/Input/CustomTextField'
import CustomSnackbar from 'components/CustomSnackbar'
import CustomSelect from 'components/Input/CustomSelect'
import CustomMultiSelect from 'components/Input/CustomMultiSelect'

export const fields = [
  'object_id',
  'categoryId',
  'alexa',
  'careField1',
  'careField2',
  'careField3',
  'careDetails',
  'products',
  'monthId',
  'careDescription',
]

const validate = values => {
  const errors = {}
  return errors
}

const onSubmit = async (values, dispatch, props) => {
  values.object_id = props.initialValues.object_id
  try {
    await props.save(values)
  } catch (err) {
    throw new SubmissionError({ _error: err.message })
  }
}

class CategoryCareInfoForm extends Component {
  static propTypes = {
    ...formPropTypes,
    genusCategories: PropTypes.array,
    icons: PropTypes.array,
    regions: PropTypes.array.isRequired,
    months: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
    fields: PropTypes.array.isRequired,
    duplicateId: PropTypes.object,
    closeDuplicate: PropTypes.func,
  }
  async componentDidMount() {
    await this.props.getRegions()
    await this.props.getMonths()
    await this.props.getGenusCategories()
    await this.props.getProducts()
    await this.props.getIcons()
    if (
      this.props.duplicateId !== undefined &&
      this.props.duplicateId !== null
    ) {
      await this.props.get(this.props.duplicateId)
    } else {
      await this.props.get(this.props.match.params.id)
    }
  }
  hideAlert = () => {
    this.props.hideAlert()
    if (this.props.duplicateId) {
      this.props.closeDuplicate()
    }
  }
  handleCloseError = () => {
    this.props.hideAlert()
  }
  backToList = () => {
    this.props.hideAlert()
    this.props.history.push('/categoryCareInfo')
  }
  render() {
    const {
      submitting,
      submitSucceeded,
      record,
      genusCategories,
      regions,
      months,
      products,
      icons,
      handleSubmit,
      error,
      duplicateId,
      closeDuplicate,
      classes,
      fetching,
      pristine,
    } = this.props
    let title = ''
    if (duplicateId !== undefined && duplicateId !== null) {
      title =
        'Duplicate ' +
        (record !== null && record.categoryId ? record.categoryId.label : '')
    } else {
      title =
        (this.props.match.params.id ? 'Edit ' : 'Add new') +
        (record !== null && record.categoryId ? record.categoryId.label : '')
    }
    return (
      <div>
        <CustomSnackbar
          variant="error"
          open={Boolean(error)}
          message={error && error.message}
          handleClose={() => this.handleCloseError()}
        />
        <CustomSnackbar
          variant="info"
          open={Boolean(submitting)}
          message="Saving"
        />
        <CustomSnackbar
          variant="success"
          open={Boolean(submitSucceeded)}
          message="Saved"
          onClose={() => {}}
        />
        <RegularCard
          cardTitle={title}
          content={
            <form onSubmit={handleSubmit}>
              <Fade in={fetching || submitting}>
                <div
                  className={classes.overlay}
                  style={{ zIndex: fetching ? 10 : 0 }}
                >
                  <CircularProgress className={classes.loadingSpinner} />
                </div>
              </Fade>
              <div>
                <Field
                  name="categoryId"
                  label="Category"
                  options={genusCategories}
                  component={CustomSelect}
                />
              </div>
              <div>
                <Field name="alexa" component={CustomTextField} label="Alexa" />
              </div>
              <div>
                <Field
                  name="careField1"
                  component={CustomTextField}
                  label="Care field 1"
                />
              </div>
              <div>
                <Field
                  name="careField2"
                  component={CustomTextField}
                  label="Care field 2"
                />
              </div>
              <div>
                <Field
                  name="careField3"
                  component={CustomTextField}
                  label="Care field 3"
                />
              </div>
              <div>
                <Field
                  multiline={true}
                  name="careDetails"
                  component={CustomTextField}
                  label="Details"
                />
              </div>
              <div>
                <Field
                  multiline={true}
                  name="careDescription"
                  component={CustomTextField}
                  label="Description"
                />
              </div>
              <div>
                <Field
                  name="products"
                  label="Products"
                  options={products}
                  component={CustomMultiSelect}
                  placeholder="Select products"
                  selectInput={<Input id="select-multiple-chip" />}
                  multiple
                />
              </div>
              <div>
                <Field
                  name="regions"
                  label="Regions"
                  options={regions}
                  placeholder="Select regions"
                  component={CustomMultiSelect}
                />
              </div>
              <div>
                <Field
                  name="monthId"
                  label="Months"
                  options={months}
                  placeholder="Select months"
                  component={CustomMultiSelect}
                />
              </div>
              <div>
                <Field
                  name="icon"
                  label="Icon"
                  options={icons}
                  placeholder="Select icon"
                  title="Icon"
                  component={CustomSelect}
                />
              </div>
            </form>
          }
          footer={
            duplicateId ? (
              <>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={fetching || pristine}
                >
                  Duplicate
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={closeDuplicate}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={fetching || pristine}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => this.props.history.push('/categoryCareInfo')}
                >
                  Back to list
                </Button>
              </>
            )
          }
        />
      </div>
    )
  }
}

const mapStateToProps = ({ categoryCareInfo }) => ({
  record: categoryCareInfo.record,
  genusCategories: categoryCareInfo.genusCategories,
  regions: categoryCareInfo.regions,
  months: categoryCareInfo.months,
  products: categoryCareInfo.products,
  icons: categoryCareInfo.icons,
  fetching: categoryCareInfo.fetching,
  fetched: categoryCareInfo.fetched,
  saving: categoryCareInfo.saving,
  saved: categoryCareInfo.saved,
  fields,
  initialValues: categoryCareInfo.record,
})

const mapDispatchToActions = { ...categoryCareInfoActions }

const styles = () => ({
  overlay,
  loadingSpinner,
})

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToActions
  )(
    reduxForm({
      form: 'categoryCareInfo',
      validate,
      onSubmit,
      enableReinitialize: true,
      keepDirtyOnReinitialize: true,
    })(CategoryCareInfoForm)
  )
)
